import React from "react";
import { X, CheckCircle, AlertCircle, Info } from "lucide-react";
import { useToast } from "../../contexts/ToastContext";
import { cn } from "../../lib/utils";

const icons = {
  default: <Info className="h-4 w-4 text-blue-500" />,
  success: <CheckCircle className="h-4 w-4 text-emerald-500" />,
  destructive: <AlertCircle className="h-4 w-4 text-red-500" />,
  warning: <AlertCircle className="h-4 w-4 text-amber-500" />,
};

const styles = {
  default: "bg-white border-slate-200",
  success: "bg-emerald-50 border-emerald-200",
  destructive: "bg-red-50 border-red-200",
  warning: "bg-amber-50 border-amber-200",
};

export function Toaster() {
  const { toasts, dismiss } = useToast();

  return (
    <div className="fixed bottom-4 right-4 z-[100] flex flex-col gap-2 w-80">
      {toasts.map((t) => (
        <div
          key={t.id}
          className={cn(
            "flex items-start gap-3 rounded-lg border p-4 shadow-lg transition-all",
            styles[t.variant] || styles.default
          )}
        >
          <span className="mt-0.5">{icons[t.variant] || icons.default}</span>
          <div className="flex-1 min-w-0">
            {t.title && <p className="text-sm font-semibold text-slate-900">{t.title}</p>}
            {t.description && <p className="text-sm text-slate-600 mt-0.5">{t.description}</p>}
          </div>
          <button
            onClick={() => dismiss(t.id)}
            className="text-slate-400 hover:text-slate-600 transition-colors"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
